module.exports = __webpack_public_path__ + "img/number_m_spritesheet.29a9cf98.png";